<template>
	<div>
		<!-- Top Navigation Bar -->
		<user-nav-menu
			v-if="isPractice()"
			bg-color="transparent"
			text-color="#fff"
			:logo-file-name="tenant.settings.brandImages.headerLogos.app.light"
			:disable-account="true"
		></user-nav-menu>
		<user-nav-menu
			v-else
			user-type="LOCUM"
			bg-color="transparent"
			text-color="#fff"
			:logo-file-name="tenant.settings.brandImages.headerLogos.app.light"
			:disable-account="true"
		></user-nav-menu>

		<v-row align="center" justify="center" class="mb-5">
			<v-col cols="11" md="7" sm="7">
				<v-overlay :value="loading"><v-progress-circular :indeterminate="true"></v-progress-circular></v-overlay>
				<h1 class="create-profile-title justify-center text-center pb-5 pt-5">Edit Profile</h1>

				<v-card class="card-rounded elevation-1 mt-3" style="width: 100%; height: auto">
					<div>
						<v-container align="center" justify="center" class="pa-5 pb-0">
							<v-list-item three-line>
								<v-list-item-content>
									<v-list-item-title class="mb-1 text-center text-wrap"><h1>Account Details</h1></v-list-item-title>
									<v-list-item-subtitle class="text-center text-wrap">Update your account preferences here</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-container>

						<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
							<v-container>
								<v-form ref="form" v-model="valid" lazy-validation class="pa-4 pt-0 text-wrap">
									<v-row class="pb-5">
										<v-text-field v-model="contactNumber" :outlined="true" label="Contact number" :rules="phoneNumberRules"></v-text-field>
									</v-row>

									<v-row>
										<v-btn class="mb-10" min-width="185" @click="changePassword">{{ displayText }}</v-btn>
									</v-row>

									<div v-show="showChangePassword">
										<v-row class="mb-3">
											<v-text-field
												id="oldPassword"
												v-model="oldPassword"
												label="Enter old password"
												outlined
												:type="showpassword ? 'text' : 'password'"
												:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
												required
												name="oldPassword"
												:rules="passwordRules"
												@click:append="showpassword = !showpassword"
											></v-text-field
										></v-row>

										<v-row class="mb-3">
											<v-text-field
												id="newPassword"
												v-model="newPassword"
												label="Enter new password"
												outlined
												:type="showpassword ? 'text' : 'password'"
												:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
												required
												name="newPassword"
												:rules="passwordRules"
												@click:append="showpassword = !showpassword"
											></v-text-field>
										</v-row>

										<v-row class="mb-3">
											<v-text-field
												id="confirmpassword"
												v-model="confirmPassword"
												label="Confirm new password"
												:rules="[...passwordRules, passwordConfirmationRule]"
												outlined
												:type="showpassword ? 'text' : 'password'"
												:append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
												name="confirmpassword"
												required
												@click:append="showpassword = !showpassword"
											></v-text-field>
										</v-row>
									</div>

									<v-row>
										<v-btn class="mb-10" href="https://www.locumbase.com/contact" target="_blank" min-width="185">Deactivate profile</v-btn>
									</v-row>
								</v-form>
							</v-container>
						</v-card-text>

						<v-snackbar v-model="snackbar" top timeout="-1" color="primary">
							{{ snackbarText }}

							<!-- eslint-disable-next-line -->
							<template v-slot:action="{ attrs }">
								<v-btn text v-bind="attrs" @click="closeSnackbar"> Close </v-btn>
							</template>
						</v-snackbar>
					</div>

					<v-card-actions align="center" justify="center" class="justify-center text-center">
						<v-container>
							<v-row align="center" justify="center">
								<v-col cols="12" sm="12" md="12">
									<v-btn
										:disabled="!valid"
										:loading="loading"
										large
										class="text-none button-rounded continue-signup-button"
										:height="54"
										color="primary"
										@click="onSubmit()"
										>Save changes<v-icon>arrow_forward</v-icon></v-btn
									>
								</v-col>
							</v-row>

							<v-row>
								<v-col cols="12" sm="12" md="12">
									<v-btn
										class="pt-0 mt-0"
										text
										link
										color="primary"
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: normal;
											font-size: 14px;
											line-height: 17px;
											text-align: right;
											text-decoration-line: underline;
										"
										@click="returnToDashboard"
									>
										return to dashboard
									</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { Auth } from 'aws-amplify';
import { apiPut } from '../../utils/api';
import store from '@/store';
import UserNavMenu from '@/components/user/UserNavMenu';

export default {
	name: 'AccountSettings',
	components: { UserNavMenu },
	props: ['pathPrefix'],
	data: () => ({
		valid: true,
		error: false,
		snackbar: false,
		snackbarText: 'Your contact number failed to update, please try again later',
		user: null,
		contactNumber: null,
		oldContactNumber: null,
		oldPassword: null,
		newPassword: null,
		confirmPassword: null,
		showpassword: false,
		showChangePassword: false,
		loading: false,
		spinning: false,
		isLocum: false,
		userType: '',
		passwordRules: [
			v => !!v || 'Password is required',
			v => v?.length >= 5 || 'Password must have 5+ characters',
			v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
			v => /(?=.*\d)/.test(v) || 'Must have one number',
		],
		phoneNumberRules: [
			v => (v && v.length === 12) || 'Phone number should have +27 followed by 9 digits',
			v => v?.startsWith('+27') || 'Phone number should have +27 followed by 9 digits',
		],
	}),
	computed: {
		passwordConfirmationRule() {
			return this.newPassword === this.confirmPassword || 'Password must match';
		},
		displayText() {
			return this.showChangePassword ? 'Hide change password' : 'Change password';
		},
	},

	async mounted() {
		this.isLocum = await store.dispatch('IsInGroup', 'Locum');
		this.user = await Auth.currentAuthenticatedUser();
		await this.getPhoneNumber();

		// choose to show a LOCUM/PRACTICE Menu
		this.chooseMenuType();
	},

	methods: {
		isPractice() {
			return !this.isLocum;
		},
		chooseMenuType() {
			if (this.isLocum) this.userType = 'LOCUM';
			else this.userType = 'PRACTICE';
		},
		validate() {
			this.$refs.form.validate();
		},
		resetValidation() {
			this.$refs.form.resetValidation();
		},
		closeSnackbar() {
			this.resetValidation();
			this.snackbar = false;
			this.error = false;
		},
		changePassword() {
			this.resetValidation();
			this.showChangePassword = !this.showChangePassword;
		},
		async getPhoneNumber() {
			const {
				attributes: { phone_number },
			} = this.user;
			this.contactNumber = phone_number;
			this.oldContactNumber = phone_number;
		},
		returnToDashboard() {
			this.$router.push('/').catch(() => {});
		},
		handleError(err) {
			this.error = true;
			this.snackbar = true;
			this.valid = false;
			console.error('Error msg: ', err);
		},
		async updateCognitoPhoneNumber() {
			if (this.contactNumber != this.oldContactNumber) {
				try {
					let response = await Auth.updateUserAttributes(this.user, {
						phone_number: this.contactNumber,
					});
					return response;
				} catch (err) {
					this.handleError(err);
				}
			}
		},
		async updateDbPhoneNumber() {
			let body = {
				contact: this.contactNumber,
			};

			try {
				await apiPut(this.pathPrefix, body);
			} catch (err) {
				this.handleError(err);
			}
		},
		async onSubmit() {
			this.validate();
			this.loading = true;

			let cognitoResponse = await this.updateCognitoPhoneNumber();

			if (cognitoResponse === 'SUCCESS') {
				await this.updateDbPhoneNumber();
			}

			if (this.oldPassword && this.newPassword && this.confirmPassword) {
				try {
					await Auth.changePassword(this.user, this.oldPassword, this.newPassword);
				} catch (err) {
					this.snackbarText = 'Your password failed to update. ' + err.message;
					this.handleError(err);
				}
			}

			if (!this.error) {
				this.$router.push('/').catch(() => {});
			}
			this.loading = false;
		},
	},
};
</script>
